import api from './api';

export default {
  async getConfig() {
    return {
      api,
    };
  },
};
